import { createConfirmation } from "react-confirm";
import SmsModal from "./SmsModal";

export const showSmsModal = createConfirmation(SmsModal);
